import { Typography, Tag } from "antd";
import {
    CheckCircleOutlined,
    ExclamationCircleOutlined,
  } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { get } from './getset'
const { Text } = Typography;

const locales = Intl.getCanonicalLocales(["NL", "default", "EN", "DE", "NL", "FR"]);
const comparer = new Intl.Collator(locales).compare;

export default function createUserMangementColumns(t,appState) {
    const createColumns = [
        {
          title: t("users.columns.userName"),
          key: "userName",
          width: 360,
          render: (record) => {
            return (
              <>
                <Link to={`/user-management/user?id=${record.id}`}>
                  {record.userName}
                </Link>
              </>
            );
          },
          sorter: (a, b) => {
            const va = get(a, "userName") || get(a, "userName", "");
            const vb = get(b, "userName") || get(b, "userName", "");
            return comparer(va, vb);
          },
          sortOrder: appState.userManagement.sorter.columnKey === "userName" && appState.userManagement.sorter.order
        },
        {
          title: t("users.columns.person"),
          dataIndex: "person",
          key: "person",
          width: 360,
          render: (person) => {
            return <Text>{person.summary}</Text>;
          },
          sorter: (a, b) => {
            const va = get(a, "person.summary") || get(a, "person.summary", "");
            const vb = get(b, "person.summary") || get(b, "person.summary", "");
            return comparer(va, vb);
          },
          sortOrder: appState.userManagement.sorter.columnKey === "person" && appState.userManagement.sorter.order
        },


      ];

      appState.useEmail && createColumns.push({
            title: t("users.columns.email"),
            dataIndex: "email",
      })
    
      appState.useEmail && createColumns.push({
          title: t("users.columns.verified"),
          dataIndex: "emailValidated",
          // width: 160,
          render: (emailValidated) => {
            return (
              <>
                {emailValidated ? (
                  <Tag icon={<CheckCircleOutlined />} color="success">
                    {t("user.emailVerified")}
                  </Tag>
                ) : (
                  <Tag icon={<ExclamationCircleOutlined />} color="warning">
                    {t("user.emailNotVerified")}
                  </Tag>
                )}
              </>
            );
          },
          filters: [
              {
                  text: t("user.emailVerified"),
                  value: true
              },
              {
                text: t("user.emailNotVerified"),
                value: false
            }
          ],
          onFilter: (value, record) => record.emailValidated === value, 
          filteredValue: appState.userManagement.filters.emailValidated

      })

      createColumns.push({
        title: t("users.columns.actions"),
        key: "actions",
        align: "center",
        width: 96,
        render: (_key) => {
          return (
            <Link to={`/user-management/user?id=${_key.id}`}>
              {t("utils:buttons.edit")}
            </Link>
          );
        }
      })

    return createColumns
}